import { Component, Input } from '@angular/core';

@Component({
  selector: 'ecp-content-spinner',
  templateUrl: './content-spinner.component.html',
  styleUrls: ['./content-spinner.component.scss'],
  standalone: false
})
export class ContentSpinnerComponent {
  /*/ Set spinner size to small /*/
  @Input() public spinnerSmall: boolean;

  constructor() {}
}
